import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface PhotoUploadErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

interface PhotoUploadErrorBoundaryProps {
  children: React.ReactNode;
  onErrorFallback?: () => void;
}

class PhotoUploadErrorBoundary extends React.Component<
  PhotoUploadErrorBoundaryProps,
  PhotoUploadErrorBoundaryState
> {
  constructor(props: PhotoUploadErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): PhotoUploadErrorBoundaryState {
    console.error('📸 PhotoUploadErrorBoundary caught error:', error);
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('📸 PhotoUploadErrorBoundary error details:', { error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="space-y-4">
          <div className="w-full p-4 bg-red-50 border border-red-200 rounded-xl">
            <div className="flex items-center space-x-2 text-red-700">
              <AlertCircle className="h-5 w-5" />
              <span className="text-sm font-medium">
                Foto-Upload temporär nicht verfügbar
              </span>
            </div>
          </div>
          <button
            onClick={() => this.props.onErrorFallback?.()}
            className="w-full p-3 bg-white/60 backdrop-blur-sm border border-white/30 rounded-xl text-gray-700 font-medium hover:bg-white/80 transition-colors"
          >
            Ohne Fotos fortfahren
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default PhotoUploadErrorBoundary;